import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Divider,
  IconButton,
} from "@mui/material";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { LeftMenu } from "../../MockItems";

import MenuIcon from "@mui/icons-material/Menu";

import Capture from "../../Assets/logo1.png";
import classNames from "classnames";

const AsideItems = ({ isCollapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openMenus, setOpenMenus] = useState({});
  const role = localStorage.getItem("role");
  const tab = JSON.parse(localStorage.getItem("tab") || []);

  //const [isCollapsed, setIsCollapsed] = useState(false);
  const toggleMenu = (id) => {
    setOpenMenus((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  // const toggleSidebar = () => {
  //   setIsCollapsed((prev) => !prev);
  // };

  console.log(LeftMenu, "ajdsdhjk", tab);

  return (
    <>
      <div
        className={classNames(
          "bg-white border-r p-2 overflow-y-auto hide-scrollbar shadow-sm transition-all ease-in-out  duration-500",
          isCollapsed ? "w-20" : "w-64",
        )}
      >
        {/* Hamburger Toggle Button */}
        {/* <div className="flex justify-end p-2">
          <IconButton onClick={toggleSidebar}>
            <MenuIcon />
          </IconButton>
        </div> */}

        <List component="nav">
          {/* Logo */}
          <div className="flex justify-center mb-2">
            <img
              alt="Logo"
              className={classNames(
                "transition-all duration-300",
                isCollapsed ? "!h-12 !w-12" : "!h-36 !w-60",
              )}
              src={Capture}
            />
          </div>

          <Divider />

          <div className="overflow-y-auto hide-scrollbar max-h-[calc(100vh-160px)]">
            {LeftMenu?.map((item) => {
              const isActive = location.pathname === item.navLink;

              if (!item?.AccessLevel?.includes(role)) return null;

              return (
                <div key={item.id}>
                  <ListItemButton
                    onClick={() =>
                      item?.children?.length > 0
                        ? toggleMenu(item.id)
                        : navigate(item.navLink)
                    }
                    className={classNames(
                      "!flex !items-center !gap-3 !px-2 !py-1 !rounded-md !w-full !text-left !transition-all !duration-200",
                      (isActive && !item?.children?.length > 0) ||
                        openMenus[item.id]
                        ? "!bg-blue-600 !text-white !font-semibold !shadow"
                        : "!hover:bg-blue-400/50",
                    )}
                  >
                    {/* Icon */}
                    {/* {item.navIcon && (
                      <ListItemIcon
                        className={classNames(
                          "!min-w-fit",
                          isActive && !item?.children?.length > 0 && "!text-white"
                        )}
                      >
                        {item.navIcon}
                      </ListItemIcon>
                    )} */}

                    {item.navIcon && (
                      <ListItemIcon className="!min-w-fit">
                        {item.navIcon &&
                          React.isValidElement(item.navIcon) &&
                          React.cloneElement(item.navIcon, {
                            className: classNames(
                              item.navIcon.props.className,
                              "!min-w-fit",
                              (isActive && !item?.children?.length > 0) ||
                                (openMenus[item.id] && "text-white"),
                            ),

                            style: {
                              ...(item.navIcon.props.style || {}),
                              fontSize: 18,
                            },
                          })}
                      </ListItemIcon>
                    )}

                    {/* Text (conditionally rendered) */}
                    {!isCollapsed && (
                      <ListItemText
                        primary={
                          <p className=" 2xl:!text-sm !text-xs">
                            {item.navItem}
                          </p>
                        }
                      />
                    )}

                    {/* Expand Icon */}
                    {item?.children?.length > 0 &&
                      !isCollapsed &&
                      (openMenus[item.id] ? <ExpandLess /> : <ExpandMore />)}
                  </ListItemButton>

                  {/* Children */}
                  {item?.children?.length > 0 && (
                    <Collapse
                      in={openMenus[item.id]}
                      timeout="auto"
                      unmountOnExit
                    >
                      <List component="div" className="!pl-4">
                        {item?.children?.map((child, idx) => {
                          const isChildActive =
                            location.pathname === child.navLink;

                          if (tab?.length === 0 || !tab.includes(child.navItem))
                            return null;
                          return (
                            <ListItemButton
                              key={idx}
                              onClick={() => navigate(child.navLink)}
                              className={classNames(
                                "!flex !items-center !gap-3 !px-4 !py-1 !rounded-md !w-full !text-left !transition-all !duration-200",
                                isChildActive
                                  ? "!bg-blue-600 !text-white !font-semibold !shadow"
                                  : "!hover:bg-blue-400/50",
                              )}
                            >
                              <ListItemIcon className="!min-w-fit">
                                {child.navIcon &&
                                  React.isValidElement(child.navIcon) &&
                                  React.cloneElement(child.navIcon, {
                                    className: classNames(
                                      child.navIcon.props.className,
                                      "text-[18px]",
                                      isChildActive && "text-white",
                                    ),

                                    style: {
                                      ...(child.navIcon.props.style || {}),
                                      fontSize: 18,
                                    },
                                  })}
                              </ListItemIcon>
                              {!isCollapsed && (
                                <ListItemText
                                  primary={
                                    <p className=" 2xl:text-sm text-xs">
                                      {child.navItem}
                                    </p>
                                  }
                                />
                              )}
                            </ListItemButton>
                          );
                        })}
                      </List>
                    </Collapse>
                  )}
                </div>
              );
            })}
          </div>
        </List>
      </div>

      {/* <div className="w-64 bg-white h-screen border-r overflow-y-auto shadow-sm">
      <List component="nav">
        <img alt="" className="Capture !h-36 !w-60" src={Capture} />
        <Divider />
        <div className="overflow-y-auto max-h-[calc(100vh-160px)]">
          {LeftMenu.map((item) => (
            <div key={item.id}>
              <ListItemButton onClick={() => toggleMenu(item.id)}>
                <ListItemIcon>{item.navIcon}</ListItemIcon>
                <ListItemText primary={item.navItem} />
                {item.children ? (
                  openMenus[item.id] ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )
                ) : null}
              </ListItemButton>
              {item.children && (
                <Collapse in={openMenus[item.id]} timeout="auto" unmountOnExit>
                  <List component="div" className="pl-4">
                    {item.children.map((child, idx) => (
                      <ListItemButton
                        key={idx}
                        onClick={() => navigate(child.navLink)}
                        className={classNames(
                          "!rounded !p-2",
                          window.location.pathname === navigate.navLink &&
                            "!bg-gray-200"
                        )}
                      >
                        <ListItemIcon
                          className={classNames(
                            window.location.pathname === navigate.navLink &&
                              "!text-white"
                          )}
                        >
                          {child.navIcon}
                        </ListItemIcon>
                        <ListItemText primary={child.navItem} />
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
              )}
            </div>
          ))}
        </div>
      </List>
    </div> */}
    </>
  );
};

export default AsideItems;
